<template>
  <input
    :disabled="disabled"
    :placeholder="placeholder"
    :type="type"
    @change="vModel($event.target.value)"
    @input="vModel($event.target.value)"
    @focus="passMethod('focus')"
    @blur="passMethod('blur')"
    :value="value"
    :class="classes"
  />
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['placeholder', 'disabled', 'value'],
  methods: {
    passMethod(eventName) {
      this.$emit(eventName);
    },
    vModel(value) {
      this.$emit('input', value);
    },
  },
};
</script>
